import customProtocolCheck from "custom-protocol-check";

const OpenFile = (
  localWordUrl: string | undefined,
  webWordUrl: string | undefined,
) => {
  // quick hack for opening pdf files
  if (localWordUrl?.includes(".pdf")) {
    return window.open(`${localWordUrl}`, "_self");
  }
  else if (webWordUrl?.includes(".pdf")) {
    return window.open(`${webWordUrl}`, "_self");
  }

  const user = JSON.parse(localStorage.getItem("user")!);
  if (user?.preferDesktopWord === true) {
    customProtocolCheck(
      `ms-word:ofe|u|${localWordUrl}`,
      () => {
        if (webWordUrl?.includes("login_hint")) {
          window.open(`${webWordUrl}`, "_self");
        } else {
          window.open(
            `${webWordUrl}&login_hint=${user.email}`,
            "_self"
          );
        }
      },
      () => {
        const isInProject = /\/home\/\d+/.test(window.location.href);
        if (!isInProject) {
          window.location.href = "/";
        }
      },
      10000,
      () => {
        if (webWordUrl?.includes("login_hint")) {
          window.open(`${webWordUrl}`, "_self");
        } else {
          window.open(
            `${webWordUrl}&login_hint=${user.email}`,
            "_self"
          );
        }
      }
    );
  } else {
    if (webWordUrl?.includes("login_hint")) {
      window.open(`${webWordUrl}`, "_self");
    } else {
      window.open(
        `${webWordUrl}&login_hint=${user.email}`,
        "_self"
      );
    }
  }
};
export default OpenFile;
